<!--
 * @Descripttion: 密码登陆组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-12 14:58:49
-->
<template>
  <div class="login-form-wrapper">
    <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
      <a-form-model-item label="手机号码" prop="phoneNumber">
        <a-input v-model="form.phoneNumber" allow-clear hide-button :disabled="loading"></a-input>
      </a-form-model-item>

      <a-form-model-item label="密码" prop="password" style="margin-top: 10px">
        <a-input-password
          style="width: 100%; height: 40px"
          v-model="form.password"
          allow-clear
          hide-button
          :disabled="loading"
        >
        </a-input-password>
      </a-form-model-item>

      <div class="register-box">
        <a-checkbox v-model="rememberMe" :disabled="loading">
          <span style="font-size: 14px; color: #a2a5ae">{{$t('base.rememberPassword')}}</span>
        </a-checkbox>
        <div class="register-link" @click="skipToForgetPwdPage">{{$t('base.forgetPassword')}}</div>
      </div>

      <a-button type="primary" class="sbmitBtn" :loading="loading" @click="handleSubmit"> 立即登录 </a-button>
    </a-form-model>
  </div>
</template>

<script>
import { login } from '@/api/auth'

export default {
  data() {
    return {
      form: {
        phoneNumber: '',
        password: '',
      },
      countdown: 0,
      loading: false,
      rememberMe: false,
    }
  },
  computed: {
    isAgree() {
      return this.$store.getters.LoginInfo.isAgree
    },
    isCountingDown() {
      return this.countdown > 0 || false
    },
    rules() {
      return {
        phoneNumber: [
          { required: true, message: this.$t('base.phoneNotEmpty'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('base.passwordNotEmpty'), trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' },
        ],
      }
    },

  },
  methods: {
    // 验证手机号
    validatePhone(rule, value, callback) {
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error(this.$t('base.phoneNumberError')))
      } else {
        callback()
      }
    },

    // 验证密码
    validatePassword(rule, value, callback) {
      // 密码必须包含大小写字母、数字、特殊字符中的至少三种，且长度不少于8位
      const passwordValidate = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-])[A-Za-z\d@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-]{8,}$/
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!passwordValidate.test(value)) {
        callback(new Error(this.$t('base.passwordRule', [8])))
      } else {
        callback()
      }
    },

    // 提交登录
    async handleSubmit() {
      try {
        await this.$refs.loginForm.validate()
        if (!this.isAgree) {
          this.$message.error(this.$t('tip.pleaseReadTip'))
          return
        }

        this.loading = true
        const params = {
          username: this.form.phoneNumber,
          password: this.form.password,
          appType: 'family',
        }

        const res = await login(params)
        if (res.code === 0) {
          // 记住密码
          if (this.rememberMe) {
            localStorage.setItem('phoneNumber', this.form.phoneNumber)
            localStorage.setItem('password', this.form.password)
          } else {
            localStorage.removeItem('phoneNumber')
            localStorage.removeItem('password')
          }

          this.$message.success('登录成功！')
          // 登录成功后跳转
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        } else {
          this.$message.error(res.message || '登录失败，请重试！')
        }
      } finally {
        this.loading = false
      }
    },

    // 跳转到找回密码页面
    skipToForgetPwdPage() {
      this.$router.push('/forgetPwd')
    },
  },
  created() {
    // 获取记住的账号密码
    const savedphoneNumber = localStorage.getItem('phoneNumber')
    const savedPassword = localStorage.getItem('password')
    if (savedphoneNumber) this.form.phoneNumber = savedphoneNumber
    if (savedPassword) this.form.password = savedPassword
  },
}
</script>

<style lang="less" scoped>
.login-form {
  margin-top: 20px;
  font-size: 18px;

  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input {
    height: 40px;
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus {
      box-shadow: none;
    }
  }

  /deep/.ant-input-affix-wrapper {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus,
    &-focused {
      box-shadow: none;
    }

    .ant-input {
      background-color: transparent;
      color: #fff;
    }
    .anticon {
      color: #a2a5ae;
    }
  }

  /deep/.ant-input-password {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    .ant-input {
      background-color: transparent;
      color: #fff;
    }

    .anticon {
      color: #a2a5ae;
    }
  }
}
.buttonCodeClass {
  font-size: 18px;
}

.register-box {
  width: 320px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
  // bottom: 30px;
  padding: 0px 5px;

  .register-link {
    color: #0166fc;
    cursor: pointer;
  }
}

.sbmitBtn {
  width: 360px;
  height: 40px;
  background: #0166fc;
  border-radius: 8px 8px 8px 8px;
}

.send-code {
  cursor: pointer;
}

/deep/.ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a2a5ae;
}
</style>
